import React, { useState, useEffect } from "react";
import CallsUtils from "Utils/CallsUtils";
import DateUtils from "Utils/DateUtils";
import ConstantObj from "Static/constant";

const getFormattedDateAndTime = (createTs = "") => {
  if (!createTs) return { date: "--", time: "--" };
  const d = new Date(createTs);
  const hour = DateUtils.getHourValue(d.getHours());
  const minutes = DateUtils.getMinutesValue(d.getMinutes());
  const seconds = DateUtils.getSecondsValue(d.getSeconds());
  const meridian = DateUtils.getMerdians(d.getHours());
  return {
    date: `${ConstantObj?.months?.[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`,
    time: `${hour}:${minutes}:${seconds} ${meridian}`
  };
};

const NotesTab = ({ call = {}, aiSummary = "", aiLoading = false }) => {
  const {
    notes = "",
    outcome = "",
    duration = 0,
    createTs = "",
    memberName = "",
    recordingUrl = "",
    toNumber = "",
    fromNumber = ""
  } = call;

  const [editing, setEditing] = useState(false);
  const [localNotes, setLocalNotes] = useState(notes);

  useEffect(() => {
    setLocalNotes(notes);
    setEditing(false);
  }, [call?.id]);

  const { date, time } = getFormattedDateAndTime(createTs);
  const formattedDuration = CallsUtils.secondsToTime(duration);

  const detailFields = [
    { label: "Outcome", value: outcome || "--" },
    { label: "Duration", value: formattedDuration },
    { label: "Date", value: date },
    { label: "Time", value: time },
    { label: "Called by", value: memberName || "--" },
    { label: "Called To", value: toNumber || "--" },
    { label: "Called From", value: fromNumber || "--" },
    { label: "Recording", value: recordingUrl ? "Available" : "Not available" }
  ];

  return (
    <div className="notesTab">
      {aiLoading && (
        <div className="aiNotesTabLoading aiNotesTabLoadingCompact">
          <div className="aiNotesTabLoadingIcon">
            <i className="material-icons aiNotesTabSpinIcon">refresh</i>
          </div>
          <p className="aiNotesTabLoadingTitle">Loading AI notes...</p>
        </div>
      )}
      {!aiLoading && aiSummary && (
        <>
          <div className="aiNotesTabBlock">
            <div className="aiNotesTabAiLabel">
              <i className="material-icons">stars</i>
              <span>AI Summary</span>
            </div>
            <p className="aiNotesTabSummary">{aiSummary}</p>
          </div>
          <hr className="notesTabDivider" />
        </>
      )}
      <div className="notesTabSection">
        <div className="notesTabLabelRow">
          <span className="notesTabSectionLabel">Call Notes</span>
          {!editing && (
            <button
              className="notesTabEditBtn"
              onClick={() => setEditing(true)}
            >
              <i className="material-icons-outlined">edit</i>
              Edit
            </button>
          )}
        </div>
        {editing ? (
          <div className="notesTabEditArea">
            <textarea
              className="notesTabTextarea"
              value={localNotes}
              autoFocus
              onChange={e => setLocalNotes(e.target.value)}
            />
            <div className="notesTabEditActions">
              <button
                className="notesTabSaveBtn"
                onClick={() => setEditing(false)}
              >
                Save
              </button>
              <button
                className="notesTabCancelBtn"
                onClick={() => {
                  setLocalNotes(notes);
                  setEditing(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <p className="notesTabNotesText">
            {localNotes || "No notes added."}
          </p>
        )}
      </div>

      <div className="notesTabDivider" />

      <div className="notesTabSection">
        <span className="notesTabSectionLabel">Call Details</span>
        <div className="notesTabDetailGrid">
          {detailFields.map(({ label, value }) => (
            <div key={label} className="notesTabDetailItem">
              <span className="notesTabDetailLabel">{label}</span>
              <span className="notesTabDetailValue">{value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotesTab;
